import { Component, OnInit } from '@angular/core';
import {CdkDragDrop,moveItemInArray} from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-drag-drop',
  templateUrl: './drag-drop.component.html',
  styleUrls: ['./drag-drop.component.css']
})
export class DragDropComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  ownedAnimals=[
    {ID:1,Name:"dog"},
    {ID:2,Name:"cat"},
    {ID:3,Name:"monkey"},
    {ID:4,Name:"pigeon"}
  ]

  onDrop(event:CdkDragDrop<any>){
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    )
  }

//   onDrop(event: Event)  {
//     if (isDragDrop(event)) {
//       moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
//     }

//     function isDragDrop(object: any): object is CdkDragDrop<string[]> {
//   return 'previousIndex' in object;
// }
//   }

}
